import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Input from "@/shared/utils/input";
import {ErrorResponse} from "@/shared/timr";

export class ReopenPage {

	constructor() {
		$("#identifier").focus();
		$("#reopenForm").submit(() => this.sendReopenForm());
	}

	private redirectToLogin() {
		window.location.href = "/timr/recording/recording.html";
	}

	private sendReopenForm() {
		$.ajax({
			url: "/timr/reopen.json",
			type: "POST",
			data: $("#reopenForm").serialize(),
			success: () => {
				BootstrapModal.info({
					title: "reopen.reopened.header",
					message: "reopen.reopened",
					buttons: [{
						text: "passwordForgotten.navigateToLogin",
						action: () => this.redirectToLogin()
					}]
				});
			},
			error: (response: ErrorResponse) => {
				Input.removeFeedback("#identifier");
				Input.addFeedback("#identifier", "has-warning", response.responseJSON?.message);
			}
		});
		return false;
	}
}

